import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollRestoration() {
  const location = useLocation();

  // Save scroll position before navigating away
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem(
        `scroll-position:${location.pathname}`,
        window.scrollY
      );
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      sessionStorage.setItem(
        `scroll-position:${location.pathname}`,
        window.scrollY
      );
    };
  }, [location.pathname]);

  // Restore scroll position after navigation
  useEffect(() => {
    const y = sessionStorage.getItem(`scroll-position:${location.pathname}`);
    if (y) {
      window.scrollTo(0, parseInt(y, 10));
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
}